import { useEffect, useState, useRef } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { HeaderWrapper } from './components/header'
import { RightToolbar } from '../partials/layout/RightToolbar'
import { ScrollTop } from './components/scroll-top'
import { Content } from './components/content'
import { FooterWrapper } from './components/footer'
import { Sidebar } from './components/sidebar'
import { ActivityDrawer, DrawerMessenger, InviteUsers, UpgradePlan } from '../partials'
import { PageDataProvider } from './core'
import { reInitMenu } from '../helpers'
import { ToolbarWrapper } from './components/toolbar'
import { WarningModal } from './core/WarningModal'
import { useWarningModalInterval } from './core/useWarningModalInterval '
import { useAuth } from '../../app/modules/auth'

// let intervalRef: NodeJS.Timeout | null = null // Move outside component
const MasterLayout = () => {
  const { currentUser } = useAuth()
  const location = useLocation()
  // useEffect(() => {
  //   reInitMenu()
  // }, [location.key])

  // const [showModal, setShowModal] = useState(false)

  // useEffect(() => {
  //   // Only create interval once globally
  //   if (!intervalRef) {
  //     // console.log('Creating global interval')
  //     intervalRef = setInterval(() => {
  //       console.log('Interval fired at:', new Date().toLocaleTimeString())
  //       setShowModal(true)
  //     }, 10000)
  //   }

  //   return () => {
  //     // Don't clean up on unmount
  //   }
  // }, [])



  // useEffect(() => {
  //   // Clear interval and reset modal when user logs out
  //   if (!currentUser) {
  //     if (intervalRef) {
  //       clearInterval(intervalRef)
  //       intervalRef = null
  //     }
  //     setShowModal(false)
  //     return
  //   }

  //   // Only create interval if user is SMART_CENTRE
  //   if ((currentUser as any)?.userType === 'SMART_CENTRE') {
  //     if (!intervalRef) {
  //       console.log('Creating global interval')
  //       intervalRef = setInterval(() => {
  //         // console.log('Interval fired at:', new Date().toLocaleTimeString())
  //         setShowModal(true)
  //       }, 900000)
  //     }
  //   }

  //   return () => {
  //     // Cleanup on unmount
  //     if (intervalRef) {
  //       clearInterval(intervalRef)
  //       intervalRef = null
  //     }
  //   }
  // }, [currentUser]) // Add currentUser to dependency array




  // const handleClose = () => {
  //   setShowModal(false)
  //   intervalRef = null // Reset the ref so it can run again
  // }


  return (
    <PageDataProvider>
      <div className='d-flex flex-column flex-root app-root' id='kt_app_root'>
        <div className='app-page flex-column flex-column-fluid' id='kt_app_page'>
          <HeaderWrapper />
          <div className='app-wrapper flex-column flex-row-fluid' id='kt_app_wrapper'>
            <Sidebar />
            <div className='app-main flex-column flex-row-fluid' id='kt_app_main'>
              <div className='d-flex flex-column flex-column-fluid'>
                <ToolbarWrapper />
                <Content>
                  <Outlet />
                </Content>
              </div>
              <FooterWrapper />
            </div>
          </div>
        </div>
      </div>

      {/* begin:: Drawers */}
      <ActivityDrawer />
      {/* <RightToolbar /> */}
      <DrawerMessenger />
      {/* end:: Drawers */}

      {/* begin:: Modals */}
      <InviteUsers />
      <UpgradePlan />
      {/* end:: Modals
      {(currentUser as any)?.userType === 'SMART_CENTRE' && (
        <WarningModal isOpen={showModal} onClose={handleClose} />
      )} */}
      <ScrollTop />
    </PageDataProvider>
  )
}

export { MasterLayout }
